'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _recompose = require('recompose');

var _immutableHelper = require('../../../../../common/utils/immutableHelper');

var _navigationActions = require('../../../../reducers/navigationActions');

var _FullScreenErrorModal = require('../../../modal/FullScreenErrorModal');

var _FullScreenErrorModal2 = _interopRequireDefault(_FullScreenErrorModal);

var _ModalActionsList = require('../../../modal/ModalActionsList');

var _ModalActionsList2 = _interopRequireDefault(_ModalActionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components


// Util
// Lib
var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        isGuest: state.getIn(['app', 'currentUser', 'isGuest'])
    };
};

// Actions


var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
    return {
        backToRoot: function backToRoot(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToRootWorkspace)());
        },
        backToLogin: function backToLogin(event) {
            event.preventDefault();
            dispatch((0, _navigationActions.navigateToLogin)());
        }
    };
};

var GenericErrorModal = function GenericErrorModal(_ref) {
    var error = _ref.error,
        showActions = _ref.showActions,
        isGuest = _ref.isGuest,
        backToRoot = _ref.backToRoot,
        backToLogin = _ref.backToLogin,
        close = _ref.close;

    var titleMessage = (0, _immutableHelper.prop)('message', error) || 'Something went wrong';
    var description = (0, _immutableHelper.prop)('description', error) || "We apologise for the inconvenience and we're working hard to fix it.  Please try again later.";
    var code = (0, _immutableHelper.prop)('code', error) || 'UNKNOWN_ERROR';

    var descriptionElement = _react2.default.createElement(
        'p',
        null,
        description
    );
    var detailsElement = _react2.default.createElement(
        'div',
        { className: 'section' },
        descriptionElement
    );

    if (showActions) {
        var guestActions = [{ text: 'Log in', func: backToLogin }];
        var loggedInActions = [{ text: 'Return to your workspace', func: backToRoot }];
        var actions = isGuest ? guestActions : loggedInActions;

        detailsElement = _react2.default.createElement(
            'div',
            null,
            descriptionElement,
            _react2.default.createElement(_ModalActionsList2.default, { actions: actions })
        );
    }

    return _react2.default.createElement(
        _FullScreenErrorModal2.default,
        { close: close },
        _react2.default.createElement(
            'h2',
            null,
            titleMessage
        ),
        detailsElement,
        _react2.default.createElement(
            'div',
            { className: 'section' },
            _react2.default.createElement(
                'p',
                null,
                'Contact ',
                _react2.default.createElement(
                    'a',
                    { href: 'mailto:support@milanote.com' },
                    'support@milanote.com'
                ),
                ' for more help.'
            ),
            _react2.default.createElement(
                'p',
                { className: 'info' },
                'Error code: ',
                _react2.default.createElement(
                    'strong',
                    null,
                    code
                )
            )
        )
    );
};

GenericErrorModal.propTypes = {
    error: _propTypes2.default.object,
    showActions: _propTypes2.default.bool,
    isGuest: _propTypes2.default.bool,
    backToRoot: _propTypes2.default.func,
    backToLogin: _propTypes2.default.func,
    close: _propTypes2.default.func
};

var enhance = (0, _recompose.compose)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps));

exports.default = enhance(GenericErrorModal);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/error/modals/components/GenericErrorModal.js
// module id = 696
// module chunks = 0